"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

// Copyright © 2022 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var As = /*#__PURE__*/function () {
  function As(service) {
    (0, _classCallCheck2["default"])(this, As);
    this._api = service;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(As, [{
    key: "getConfiguration",
    value: function () {
      var _getConfiguration = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.As.GetConfiguration();

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getConfiguration() {
        return _getConfiguration.apply(this, arguments);
      }

      return getConfiguration;
    }()
  }, {
    key: "encodeDownlink",
    value: function () {
      var _encodeDownlink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(appId, deviceId, data) {
        var result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.AppAs.EncodeDownlink({
                  routeParams: {
                    'end_device_ids.application_ids.application_id': appId,
                    'end_device_ids.device_id': deviceId
                  }
                }, data);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function encodeDownlink(_x, _x2, _x3) {
        return _encodeDownlink.apply(this, arguments);
      }

      return encodeDownlink;
    }()
  }, {
    key: "decodeDownlink",
    value: function () {
      var _decodeDownlink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(appId, deviceId, data) {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.AppAs.DecodeDownlink({
                  routeParams: {
                    'end_device_ids.application_ids.application_id': appId,
                    'end_device_ids.device_id': deviceId
                  }
                }, data);

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function decodeDownlink(_x4, _x5, _x6) {
        return _decodeDownlink.apply(this, arguments);
      }

      return decodeDownlink;
    }()
  }, {
    key: "decodeUplink",
    value: function () {
      var _decodeUplink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(appId, deviceId, data) {
        var result;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.AppAs.DecodeUplink({
                  routeParams: {
                    'end_device_ids.application_ids.application_id': appId,
                    'end_device_ids.device_id': deviceId
                  }
                }, data);

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function decodeUplink(_x7, _x8, _x9) {
        return _decodeUplink.apply(this, arguments);
      }

      return decodeUplink;
    }()
  }]);
  return As;
}();

var _default = As;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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